"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

// Copyright © 2022 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var As = /*#__PURE__*/function () {
  function As(service) {
    (0, _classCallCheck2["default"])(this, As);
    this._api = service;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(As, [{
    key: "getConfiguration",
    value: function () {
      var _getConfiguration = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.As.GetConfiguration();

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getConfiguration() {
        return _getConfiguration.apply(this, arguments);
      }

      return getConfiguration;
    }()
  }, {
    key: "encodeDownlink",
    value: function () {
      var _encodeDownlink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(appId, deviceId, data) {
        var result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.AppAs.EncodeDownlink({
                  routeParams: {
                    'end_device_ids.application_ids.application_id': appId,
                    'end_device_ids.device_id': deviceId
                  }
                }, data);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function encodeDownlink(_x, _x2, _x3) {
        return _encodeDownlink.apply(this, arguments);
      }

      return encodeDownlink;
    }()
  }, {
    key: "decodeDownlink",
    value: function () {
      var _decodeDownlink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(appId, deviceId, data) {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.AppAs.DecodeDownlink({
                  routeParams: {
                    'end_device_ids.application_ids.application_id': appId,
                    'end_device_ids.device_id': deviceId
                  }
                }, data);

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function decodeDownlink(_x4, _x5, _x6) {
        return _decodeDownlink.apply(this, arguments);
      }

      return decodeDownlink;
    }()
  }, {
    key: "decodeUplink",
    value: function () {
      var _decodeUplink = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(appId, deviceId, data) {
        var result;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.AppAs.DecodeUplink({
                  routeParams: {
                    'end_device_ids.application_ids.application_id': appId,
                    'end_device_ids.device_id': deviceId
                  }
                }, data);

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function decodeUplink(_x7, _x8, _x9) {
        return _decodeUplink.apply(this, arguments);
      }

      return decodeUplink;
    }()
  }]);
  return As;
}();

var _default = As;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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